import React, { useContext } from "react";
import { FormBuilderContext, ACTIONS } from "../context/context";
import InputSection from "../components/InputSection";
import ColorPickerInput from "../components/ColorPickerInput";
import { FormBuilderSwitch } from "../components/Switch";
import CustomSelect from "../components/CustomSelect";
import FontFamilySelect from "../components/FontFamilySelect";

const ToggleGroup = () => {
    const { state, dispatch } = useContext(FormBuilderContext);

    const handleToggleToggle = (event) => {
        dispatch({
            type: ACTIONS.TOGGLE_TOGGLE,
            payload: event.target.checked,
        });
    };

    const handleColorChange = (actionType) => (color) => {
        dispatch({ type: actionType, payload: color });
    };

    const handleTogglePositionChange = (event) => {
        dispatch({
            type: ACTIONS.TOGGLE_POSITION,
            payload: event.target.value,
        });
    };

    const handleToggleFontWeightChange = (event) => {
        dispatch({
            type: ACTIONS.TOGGLE_LABEL_FONT_WEIGHT_INPUT,
            payload: event.target.value,
        });
    };
    
    const handleToggleLabelFontFamilyChange = (event) => {
        dispatch({
            type: ACTIONS.TOGGLE_LABEL_FONT_FAMILY_CHANGE,
            payload: event.target.value,
        });
    };

    return (
        <div>
            <div>
            <p>In order to apply the toggle styling, add this class to the fields you want it on, in Pardot:<br></br>
            <b>custom-toggle</b>
            <br></br>
            <br></br>
             </p>

          </div>
            <p>Add toggle button? </p>
            <FormBuilderSwitch
                checked={state.addToggle}
                onChange={handleToggleToggle}
            />
            {state.addToggle && (
                <>
                    <div>
                        <h2 className="section-subheader">General styles</h2>
                        <div className="input-group-wrapper">
                           
                            <InputSection
                                id="toggleMarginBottom"
                                title="Margin Bottom"
                                value={state.toggleMarginBottom}
                                actionTypeIncrement={ACTIONS.TOGGLE_MARGIN_BOTTOM_INCREMENT}
                                actionTypeDecrement={ACTIONS.TOGGLE_MARGIN_BOTTOM_DECREMENT}
                                actionTypeInput={ACTIONS.TOGGLE_MARGIN_BOTTOM}
                                dispatch={dispatch}
                            />

                            <InputSection
                                id="toggleMarginRight"
                                title="Margin Right"
                                value={state.toggleMarginRight}
                                actionTypeIncrement={ACTIONS.TOGGLE_MARGIN_RIGHT_INCREMENT}
                                actionTypeDecrement={ACTIONS.TOGGLE_MARGIN_RIGHT_DECREMENT}
                                actionTypeInput={ACTIONS.TOGGLE_MARGIN_RIGHT}
                                dispatch={dispatch}
                            />
                            <div className="form-builder-section-div">
                                <p>Align Toggles</p>
                                <CustomSelect
                                    labelId="toggle-alignment"
                                    id="toggle-alignment"
                                    selectValue={state.togglePosition}
                                    selectLabel="Toggle Alignment"
                                    selectOnChange={handleTogglePositionChange}
                                    menuItems={[
                                        { value: "relative", label: "left" },
                                        { value: "absolute", label: "right" },
                                    ]}
                                />
                            </div>
                        </div>
                        
                    </div>
                    <div>
                        <h2 className="section-subheader">Unchecked styles</h2>
                        <div className="input-group-wrapper">

                            <InputSection
                                id="toggleWidth"
                                title="Toggle Width"
                                value={state.toggleWidth}
                                actionTypeIncrement={ACTIONS.TOGGLE_WIDTH_INCREMENT}
                                actionTypeDecrement={ACTIONS.TOGGLE_WIDTH_DECREMENT}
                                actionTypeInput={ACTIONS.TOGGLE_WIDTH}
                                dispatch={dispatch}
                            />

                            <InputSection
                                id="toggleHeight"
                                title="Toggle Height"
                                value={state.toggleHeight}
                                actionTypeIncrement={ACTIONS.TOGGLE_HEIGHT_INCREMENT}
                                actionTypeDecrement={ACTIONS.TOGGLE_HEIGHT_DECREMENT}
                                actionTypeInput={ACTIONS.TOGGLE_HEIGHT}
                                dispatch={dispatch}
                            />

                            <div className="form-builder-section-div">
                                <p>Background Color</p>
                                <ColorPickerInput
                                    color={state.toggleBackgroundColor}
                                    onChange={handleColorChange(
                                        ACTIONS.TOGGLE_BACKGROUND_COLOR
                                    )}
                                />
                            </div>

                            <InputSection
                                id="toggleBorderWidth"
                                title="Border Width"
                                value={state.toggleBorderWidth}
                                actionTypeIncrement={ACTIONS.TOGGLE_BORDER_WIDTH_INCREMENT}
                                actionTypeDecrement={ACTIONS.TOGGLE_BORDER_WIDTH_DECREMENT}
                                actionTypeInput={ACTIONS.TOGGLE_BORDER_WIDTH}
                                dispatch={dispatch}
                            />

                            <InputSection
                                id="toggleBorderRadius"
                                title="Border Radius"
                                value={state.toggleBorderRadius}
                                actionTypeIncrement={ACTIONS.TOGGLE_BORDER_RADIUS_INCREMENT}
                                actionTypeDecrement={ACTIONS.TOGGLE_BORDER_RADIUS_DECREMENT}
                                actionTypeInput={ACTIONS.TOGGLE_BORDER_RADIUS}
                                dispatch={dispatch}
                            />

                            <div className="form-builder-section-div">
                                <p>Border Color</p>
                                <ColorPickerInput
                                    color={state.toggleBorderColor}
                                    onChange={handleColorChange(
                                        ACTIONS.TOGGLE_BORDER_COLOR
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                    <div>

                        <h2 className="section-subheader">Knob Styles</h2>
                        <div className="input-group-wrapper">
                            <InputSection
                                id="toggleKnobWidth"
                                title="Toggle Knob Width"
                                value={state.toggleKnobWidth}
                                actionTypeIncrement={ACTIONS.TOGGLE_KNOB_WIDTH_INCREMENT}
                                actionTypeDecrement={ACTIONS.TOGGLE_KNOB_WIDTH_DECREMENT}
                                actionTypeInput={ACTIONS.TOGGLE_KNOB_WIDTH}
                                dispatch={dispatch}
                            />

                            <InputSection
                                id="toggleKnobHeight"
                                title="Toggle Knob Height"
                                value={state.toggleKnobHeight}
                                actionTypeIncrement={ACTIONS.TOGGLE_KNOB_HEIGHT_INCREMENT}
                                actionTypeDecrement={ACTIONS.TOGGLE_KNOB_HEIGHT_DECREMENT}
                                actionTypeInput={ACTIONS.TOGGLE_KNOB_HEIGHT}
                                dispatch={dispatch}
                            />

                            <div className="form-builder-section-div">
                                <p>Toggle Knob Color</p>
                                <ColorPickerInput
                                    color={state.toggleKnobColor}
                                    onChange={handleColorChange(
                                        ACTIONS.TOGGLE_KNOB_COLOR
                                    )}
                                />
                            </div>

                            <InputSection
                                id="toggleKnobAlignment"
                                title="Toggle Knob Alignment"
                                value={state.toggleKnobAlignment}
                                actionTypeIncrement={ACTIONS.TOGGLE_KNOB_ALIGNMENT_INCREMENT}
                                actionTypeDecrement={ACTIONS.TOGGLE_KNOB_ALIGNMENT_DECREMENT}
                                actionTypeInput={ACTIONS.TOGGLE_KNOB_ALIGNMENT}
                                dispatch={dispatch}
                            />

                        </div>

                        <h2 className="section-subheader">Checked styles</h2>
                        <div className="input-group-wrapper">
                            <div className="form-builder-section-div">
                                <p>Background Color</p>
                                <ColorPickerInput
                                    color={state.toggleKnobCheckedBackgroundColor}
                                    onChange={handleColorChange(
                                        ACTIONS.TOGGLE_CHECKED_BACKGROUND_COLOR
                                    )}
                                />
                                </div>
<div className="form-builder-section-div">
                                <p>Knob Color</p>
                                <ColorPickerInput
                                    color={state.toggleKnobCheckedColor}
                                    onChange={handleColorChange(
                                        ACTIONS.TOGGLE_KNOB_CHECKED_COLOR
                                    )}
                                />
</div>
                                
                            
                        </div>
                    </div>

                    <h2 className="section-subheader">Label Font styles</h2>
                    <div className="input-group-wrapper">
                        <div className="form-builder-section-div">
                            <p>Font Family</p>
                            <FontFamilySelect
                                selectedFontFamily={state.toggleLabelFontFamily}
                                onFontFamilyChange={handleToggleLabelFontFamilyChange}
                            />
                        </div>

                        <InputSection
                            id="toggleFontSize"
                            title="Font size"
                            value={state.toggleLabelFontSize}
                            actionTypeIncrement={ACTIONS.TOGGLE_LABEL_FONT_SIZE_INCREMENT}
                            actionTypeDecrement={ACTIONS.TOGGLE_LABEL_FONT_SIZE_DECREMENT}
                            actionTypeInput={ACTIONS.TOGGLE_LABEL_FONT_SIZE_INPUT}
                            dispatch={dispatch}
                        />
                        <div>
                            <p>Font Weight</p>
                            <CustomSelect
                                labelId="font-weight-toggle"
                                id="font-weight-toggle"
                                selectValue={state.toggleLabelFontWeight}
                                selectLabel="Font Weight"
                                selectOnChange={handleToggleFontWeightChange}
                                menuItems={[
                                    { value: 100, label: "100" },
                                    { value: 200, label: "200" },
                                    { value: 300, label: "300" },
                                    { value: 400, label: "400" },
                                    { value: 500, label: "500" },
                                    { value: 600, label: "600" },
                                    { value: 700, label: "700" },
                                    { value: 800, label: "800" },
                                    { value: 900, label: "900" },
                                ]}
                            />
                        </div>
                    </div>

                    <h2 className="section-subheader">Label Color styles </h2>
                    <div className="input-group-wrapper">
                        <div className="form-builder-section-div">
                            <p>Text Color</p>
                            <ColorPickerInput
                                color={state.inputColor}
                                onChange={handleColorChange(ACTIONS.TOGGLE_LABEL_COLOR_INPUT)}
                            />
                        </div>

                    </div>
        </>

             
            )}
        </div>
    );
};

export default ToggleGroup;
